import { z } from 'zod';
import { MANUAL_MAIL_EVENTS, TEAM_REMINDER_KINDS } from '../types/support-auto-mail.js';
const email = z.string().trim().toLowerCase().email('Enter a valid email address').max(254);
export const ManualMailEventSchema = z.enum(MANUAL_MAIL_EVENTS);
/** Settings → Auto mail → Manual handle. One template, replaced as a whole. */
export const SaveManualMailTemplateSchema = z.object({
    enabled: z.boolean(),
    toCustomer: z.boolean(),
    toAccountManager: z.boolean(),
    extraEmails: z.array(email).max(10, 'Add at most 10 addresses'),
    alsoInConversation: z.boolean(),
    subject: z.string().trim().min(1, 'Write a subject').max(200),
    body: z.string().trim().min(1, 'Write the message').max(8000),
});
/**
 * Renders the saved template, or the subject and body sent with the request
 * (the form's draft), with a ticket's values or sample values.
 */
export const PreviewManualMailSchema = z.object({
    ticketId: z.string().uuid().optional(),
    subject: z.string().max(200).optional(),
    body: z.string().max(8000).optional(),
});
export const AutoMailLogQuerySchema = z.object({
    kind: z.string().trim().max(64).optional(),
});
const subject = z.string().trim().min(1, 'Write a subject').max(200);
const body = z.string().trim().min(1, 'Write the message').max(8000);
/** Settings → Auto mail → Team reminders. The whole row, replaced at once. */
export const SaveTeamReminderSettingsSchema = z.object({
    assignedEnabled: z.boolean(),
    assignedSubject: subject,
    assignedBody: body,
    ignoredEnabled: z.boolean(),
    ignoredMinutes: z
        .number()
        .int()
        .min(1, 'Enter between 1 minute and 7 days')
        .max(10080, 'Enter between 1 minute and 7 days'),
    ignoredRepeat: z.boolean(),
    ignoredSubject: subject,
    ignoredBody: body,
    digestEnabled: z.boolean(),
    digestTime: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Use a time like 09:00'),
    digestWorkingDaysOnly: z.boolean(),
    digestSubject: subject,
    digestBody: body,
});
export const TeamReminderKindSchema = z.enum(TEAM_REMINDER_KINDS);
/**
 * Renders the saved text, or the subject and body sent with the request
 * (the form's draft). Sample values when the admin has no matching tickets.
 */
export const PreviewTeamReminderSchema = z.object({
    subject: z.string().max(200).optional(),
    body: z.string().max(8000).optional(),
});
//# sourceMappingURL=support-auto-mail.schema.js.map